import React, { FC } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import { CategoryChipProps } from '@components/ncFileVersions/components/NCFileDiffView/ChangeSummaryPanel/types';
import {
  CATEGORY_COLOR_TOKEN,
  CATEGORY_DOT_SIZE,
  CATEGORY_TITLE_KEY,
} from '../../constants/changeSummaryPanel.constants';

const CategoryChip: FC<CategoryChipProps> = ({ C, category, count }) => {
  const dotColor = C(CATEGORY_COLOR_TOKEN[category]);
  const title = i18n.t(CATEGORY_TITLE_KEY[category]);
  return (
    <View style={styles.chip}>
      <View style={[styles.dot, { backgroundColor: dotColor }]} />
      <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>
        {`${count} `}
        <Text style={[font.Body, { color: C('Label/Light/Secondary') }]}>{title.toLowerCase()}</Text>
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(6),
  },
  dot: {
    width: scale(CATEGORY_DOT_SIZE),
    height: scale(CATEGORY_DOT_SIZE),
    borderRadius: scale(CATEGORY_DOT_SIZE) / 2,
  },
});

export default CategoryChip;
